<template>
  <form id="retention-form" class="kt-form" @submit.prevent="submitStorageRetentionForm">
    <div class="form-group">
      <label>Retention Type</label>
      <div class="kt-radio-inline">
        <label class="kt-radio">
          <input v-model="form.type" type="radio"
                 value="item"
                 name="retention_type"> {{ getItemLabel(true) }}
          <span />
        </label>
        <label class="kt-radio">
          <input v-model="form.type" type="radio"
                 value="storage"
                 name="retention_type"> Storage
          <span />
        </label>
      </div>
      <span class="form-text text-muted"> Choose to create retention period for {{ getItemLabel() }}s or storage </span>
    </div>
    <div class="form-group">
      <div class="d-flex flex-column">
        <ss-checkbox id="delete-related" v-model="form.delete_related">
          Delete related {{ form.type === 'storage' ? getItemLabel() + 's' : 'storage' }} (recommended)
        </ss-checkbox>
        <span v-if="form.type === 'storage'" class="form-text text-muted">
          If checked, when a storage asset is deleted, any {{ getItemLabel() }}s using this {{ getItemLabel() }} will also be deleted.
        </span>
        <span v-else class="form-text text-muted">If checked, when an {{ getItemLabel() }} is deleted, the storage asset will also be deleted.</span>
      </div>
    </div>

    <div v-if="form.type === 'item'" class="form-group">
      <div>
        <label for="retention_item_tags">Only apply this retention period to {{ getItemLabel() }}s with given Tags ?</label>
        <multiselect
          id="retention_item_tags"
          v-model="ms_tag_values"
          :options="auto_complete_tags"
          :multiple="true"
          :taggable="true"
          track-by="uuid"
          label="name"
          placeholder="Search for or add tag(s)..."
          @tag="addNewTag" />
        <span class="form-text text-muted">These tags will be added to the {{ getItemLabel() }} when it's created. This can be used to trigger adding the {{ getItemLabel() }} to playlists.</span>
      </div>
    </div>

    <!-- RETENTION PERIOD -->
    <div class="form-group">
      <label for="duration-days">Choose Retention Period (days):</label>
      <input id="duration-days"
             :value="form.retention_days"
             class="form-control col-md-2"
             name="duration-days"
             type="text"
             @input="handleDaysInput">
    </div>

    <div v-if="form.type === 'item'" class="form-group">
      <label>Check retention days against : </label>
      <div class="kt-radio-inline">
        <label class="kt-radio">
          <input v-model="form.check_against" type="radio"
                 value="created_at"
                 name="check_against"> Created At
          <span />
        </label>
        <label class="kt-radio">
          <input v-model="form.check_against" type="radio"
                 value="publish_start"
                 name="check_against"> Publish Date
          <span />
        </label>
      </div>
      <span class="form-text text-muted"> Choose to create retention period for {{ getItemLabel() }}s or storage </span>
    </div>

    <customer-retention-explaination :retention="form" />

    <b-button variant="ss-standout" type="submit"
              form="retention-form">
      {{ `${ is_update ? 'Update' : 'Save' } Retention Configuration` }}
    </b-button>
    <b-button variant="ss" @click="$modal.hide(`customer-retention-modal`)">
      Cancel
    </b-button>
  </form>
</template>

<script>
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';
import CustomerRetentionExplaination from "VuePartials/App/CustomerRetention/CustomerRetentionExplaination";
export default {
  components: { CustomerRetentionExplaination },
  mixins: [TaggableModelMixin],
  props: {
    isModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    inAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    customerRetention: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    customer: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      form: {},
      user: window.user,
      customers: [],
      auto_complete_tags: [],
    };
  },
  computed: {
    is_update() {
      // Are we editing a retention period ?
      return this.customerRetention && this.customerRetention.id;
    },
    form_data() {
      return {
        retention_days: this.form.retention_days,
        type: this.form.type,
        delete_related: this.form.delete_related,
        tags: this.ms_tag_values.map(tag => tag.name),
        check_against: this.form.check_against,
      };
    },
  },
  beforeMount() {
    this.setDefaultFormData();
    this.fetchTags();
  },
  mounted() {
    if (this.inAdmin) {
      axios.get('/api/v1/customers').then((response) => {
        this.customers = response.data.data;
        if (this.customer && this.customer.id) {
          this.selected_customer = _.find(this.customers, {
            'id': this.customer.id,
          });
        }
      });
    }
  },
  methods: {
    /**
     * TODO: this is a perfect input sanitiser for number inputs; probably should look to replicate it.
     */
    handleDaysInput(ev) {
      const value = parseInt(ev.target.value.replaceAll(/[^\d.]/g, ''));
      if (!isNaN(value)) {
        const days = Math.max(0, Math.min(100, Math.abs(value)));
        this.form.retention_days = days;
      } else if (ev.target.value.length === 0) {
        this.form.retention_days = 0;
      }
      ev.target.value = this.form.retention_days;
    },
    setDefaultFormData() {
      this.form = {
        retention_days: 0,
        tags: [],
        selected_customer: null,
        type: 'item',
        delete_related: 1,
        check_against: `created_at`,
      };
    },
    async submitStorageRetentionForm() {
      try {
        await axios.post('/api/v1/customer-retention', this.form_data);
        toastr.success("Retention configuration saved");
        this.setDefaultFormData();
        if (this.isModal) {
          this.$emit('input', this.form_data);
          EventBus.$emit('customer_retention_table-reload');
        }
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
};
</script>
